module.exports = __webpack_public_path__ + "media/images/area/area_niigataM400-2638442b0f8cd5f1bf6e2a3eae72aa0a.jpg";